// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__az5lS","footer":"ModalUpdate_footer__l0nTu"};